import type {ProblemOccurrence} from '../../../services/rest'
import type {Countable, ProblemsTreeNodeId} from '../../../types'
import type {KeyValue} from '../../../utils/object'

type ProblemOccurrencesCounts = {
  count?: number
  newFailed?: number
}

type ProblemOccurrences = ProblemOccurrencesCounts &
  Countable & {
    problemOccurrence?: ReadonlyArray<ProblemOccurrence>
  }

export enum TreeEntityType {
  PROJECT = 'PROJECT',
  BUILD_TYPE = 'BUILD_TYPE',
  BUILD = 'BUILD',
  PROBLEM_TYPE = 'PROBLEM_TYPE',
}

type BaseProblemOccurrencesTreeLeaf<T> = {
  nodeId: ProblemsTreeNodeId
  problemOccurrences?: T
}
export type ProblemOccurrencesTreeLeaf = BaseProblemOccurrencesTreeLeaf<ProblemOccurrences>
export type ProblemOccurrencesTreeNode = {
  id: ProblemsTreeNodeId
  parentId?: ProblemsTreeNodeId
  name: string
  childrenCount?: number
  count?: number
  newFailedCount?: number
  type: TreeEntityType
}
type BaseProblemOccurrencesTree<T> = {
  leaf?: ReadonlyArray<BaseProblemOccurrencesTreeLeaf<T>>
  node?: ReadonlyArray<ProblemOccurrencesTreeNode>
}
export type ProblemOccurrencesTree = BaseProblemOccurrencesTree<ProblemOccurrences>

export type ProblemOccurrencesSubtree = {
  depth?: number
  data: ProblemOccurrencesTree
}

export type BuildProblemsState = {
  problemOccurrencesSubtree: KeyValue<string, KeyValue<string, ProblemOccurrencesSubtree>>
}
